import * as THREE from 'three';

export function createScene(): THREE.Scene {
  const scene = new THREE.Scene();
  scene.background = new THREE.Color(0x87CEEB); // Himmelblau statt dunkelblau

  // Verbesserte Beleuchtung
  const ambient = new THREE.AmbientLight(0xffffff, 0.6); // Mehr ambient light
  scene.add(ambient);

  const sunLight = new THREE.DirectionalLight(0xffffff, 1.2); // Stärkeres Sonnenlicht
  sunLight.position.set(50, 80, 50);
  sunLight.castShadow = true;
  sunLight.shadow.mapSize.set(4096, 4096);
  sunLight.shadow.camera.near = 0.5;
  sunLight.shadow.camera.far = 400;
  sunLight.shadow.camera.left = -200;
  sunLight.shadow.camera.right = 200;
  sunLight.shadow.camera.top = 200;
  sunLight.shadow.camera.bottom = -200;
  scene.add(sunLight);

  // Zusätzliches Fill-Licht von der anderen Seite
  const fillLight = new THREE.DirectionalLight(0x8899ff, 0.3);
  fillLight.position.set(-50, 30, -50);
  scene.add(fillLight);

  // Weniger aggressiver Fog für bessere Sicht
  scene.fog = new THREE.Fog(0x87CEEB, 80, 400);

  return scene;
}
